<app-header></app-header>

<div class="container-fluid" style="width: 80%">
  <div class="row mt-4 mb-4">
    <div class="col">
      <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
        <ol class="breadcrumb mb-0 p-0">
          <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
          <li class="breadcrumb-item"><a routerLink="/home">Admin</a><span class="separator">/</span></li>
          <li class="breadcrumb-item active" aria-current="page">Esito UVM con PAI</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col">
      <h4>Invio esito UVM con PAI</h4>
      <p class="text-muted small mb-0">Invia l'esito UVM (con Piano Assistenziale Individuale) per una richiesta per far proseguire il workflow.</p>
    </div>
  </div>

  @if (message) {
    <div class="row mb-3">
      <div class="col">
        <div class="alert" [class.alert-success]="!isError" [class.alert-danger]="isError" role="alert">
          {{ message }}
        </div>
      </div>
    </div>
  }

  <mat-card appearance="outlined" class="mb-4">
    <mat-card-header>
      <mat-card-title><b>Dati richiesta e esito</b></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (loadingSettings) {
        <p><mat-spinner diameter="24"></mat-spinner> Caricamento setting...</p>
      } @else {
        <div class="row g-3">
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>ID richiesta</mat-label>
              <input matInput type="number" [(ngModel)]="richiestaId" placeholder="es. 9" min="1" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Sistema richiedente</mat-label>
              <input matInput [(ngModel)]="sistemaRichiedente" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Codice operatore</mat-label>
              <input matInput [(ngModel)]="operatoreCodice" placeholder="codice referente operatore" />
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data inizio</mat-label>
              <input matInput type="date" [(ngModel)]="dataInizio" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data fine</mat-label>
              <input matInput type="date" [(ngModel)]="dataFine" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Setting</mat-label>
              <mat-select [(ngModel)]="cambioSetting">
                @for (s of settings; track s.codice) {
                  <mat-option [value]="s.codice">{{ s.descrizione ?? s.codice }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cod. profilo cura</mat-label>
              <input matInput [(ngModel)]="codProfiloCura" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Desc. profilo cura</mat-label>
              <input matInput [(ngModel)]="descProfiloCura" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>ID piano assistenziale (PAI)</mat-label>
              <input matInput [(ngModel)]="identificativoPianoAssistenziale" />
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>ID scheda valutazione</mat-label>
              <input matInput [(ngModel)]="identificativoSchedaValutazione" />
            </mat-form-field>
          </div>

          <div class="col-12"><hr class="my-2" /><p class="small text-muted mb-2">Intervento (almeno uno)</p></div>
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cod. tipo erogatore</mat-label>
              <input matInput [(ngModel)]="codTipoErogatore" />
            </mat-form-field>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Tipo frequenza</mat-label>
              <input matInput [(ngModel)]="tipoFrequenza" />
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>N. accessi previsti</mat-label>
              <input matInput type="number" [(ngModel)]="numeroAccessiPrevisti" min="0" />
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Cod. attività</mat-label>
              <input matInput [(ngModel)]="codAttivita" placeholder="opzionale" />
            </mat-form-field>
          </div>

          <div class="col-12">
            <button mat-raised-button color="primary" (click)="invia()" [disabled]="sending">
              @if (sending) {
                <mat-spinner diameter="20" class="me-2"></mat-spinner>
              }
              Invia esito UVM con PAI
            </button>
          </div>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>

<app-footer></app-footer>
